<template>
  <div name="demo-searchbox-condition">
  	searchbox condition
  </div>
</template>

<script>
export default {
  name: 'demo-searchbox-condition'
}
</script>


// WEBPACK FOOTER //
// demoSearchboxCondition.vue?1eb3db9e